import {AvailableFilesTable} from "./table/AvailableFilesTable";
import {Card, message, Modal} from "antd";
import {fileService} from "../../services/fileService";
import React, {useState} from "react";
import ExclamationCircleOutlined from "@ant-design/icons/lib/icons/ExclamationCircleOutlined";
import {createMarkup} from "../DesignSystem/ActionDropdown/ActionDropdown";
import {chatService} from "../../services/chatService";
import {useHistory} from "react-router-dom";
import {getErrorFromResponse} from "../../utils/error.utils";

const {confirm} = Modal;


export function showConfirm(title, content, onOk, onCancel = undefined, okText = "OK", cancelText = "Cancel") {
    confirm({
        okText: okText,
        cancelText: cancelText,
        title: title,
        icon: <ExclamationCircleOutlined/>,
        content: <div dangerouslySetInnerHTML={createMarkup(content)}/>,
        onOk() {
            onOk();
        },
        onCancel() {
            if (onCancel != undefined) {
                onCancel();
            }
        }
    });
}

export const AvailableFiles = ({user}) => {

    const [reloadTable, setReloadTable] = useState(undefined);
    let history = useHistory();

    const fetchFiles = (page, size) => {
        return fileService.fetchAllFiles(page, size).then(response => {
            return Promise.resolve(response);
        })
    }

    const handleDeleteFile = (fileId, fileName) => {

        showConfirm("Confirmation", `Do you really want to delete the file <strong>${fileName}?</strong>`, () => {

            fileService.deleteFile(fileId).then(() => {
                message.info("File deleted successfully");
                setReloadTable(Math.random());
            }).catch(error => {
                message.error("Error deleting file");
            });

        });

    }

    const handleSelectFile = (fileId) => {

        chatService.getChatsUsingFile(fileId).then(response => {

            const chats = response.data;

            if (chats.length > 0) {
                showConfirm("Confirmation", `This file is already used in ${chats.length} chat(s). What would you like to do?`, () => {
                        history.push(`/chats/${chats[0].id}`);
                    }, () => {
                        chatService.useFile(fileId).then(response => {
                            history.push(`/chats/${response.data.id}`);
                        }).catch(error => {
                            message.error(getErrorFromResponse(error));
                        });
                    },
                    "Open an existing chat", "Create a new chat");
            } else {
                chatService.useFile(fileId).then(response => {
                    history.push(`/chats/${response.data.id}`);
                }).catch(error => {
                    message.error(getErrorFromResponse(error));
                });
            }

        }).catch(() => {
            message.error("Error fetching chats using file");
        });
    }

    return (
        <Card>
            <h4>Available files</h4>
            <AvailableFilesTable
                fetchData={fetchFiles}
                renderEmpty={() => <div>No files available</div>}
                user={user}
                reload={reloadTable}
                onSelectFile={handleSelectFile}
                onDeleteFile={handleDeleteFile}/>

        </Card>


    );

}